// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@tps/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { hideElementOnPrint, mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 2, 6, 6],
};
headerStyles.titleGridItem = {
    width: [10, 10, 10, 6, 6],
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        menu: css`
            ${hideElementOnPrint}
        `,
    },
};
headerStyles.buttonsHiddenContainer = {
    ...mergeWithCss(headerStyles.buttonsHiddenContainer, {
        css: css`
            display: flex;
        `,
    }),
};

headerStyles.downloadButton = {
    buttonType: "outline",
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};
